import { faEnvelope, faUserHeadset } from '@fortawesome/pro-light-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useWhatsappLinkSimple } from '@/hooks/use-whatsapp/use-whatsapp-link-simple.hook';
import { partnerSacEmail } from '@/utils/consts/partner.consts';
import { phoneProfessionalSac } from '@/utils/consts/sac.consts';
import { partnerSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const ProfessionalContactCard = () => {
  const { url: whatsappUrl } = useWhatsappLinkSimple(
    phoneProfessionalSac,
    partnerSacWhatsappMessage,
  );

  return (
    <section className="flex flex-col gap-5 w-full pt-6">
      <Typography
        variant={TypographyVariant.LARGE_SUBTITLE}
        as="h2"
        className="font-bold text-gray-900"
      >
        Atendimento para profissional da saúde
      </Typography>
      <Card
        className="flex flex-col gap-4 p-5"
        data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_CONTACT_CARD}
      >
        <div className="flex items-center gap-2">
          <span className="bg-green-50 border border-gray-200/25 rounded-lg w-12 h-12 flex items-center justify-center shrink-0">
            <Icon icon={faUserHeadset} className="w-6 h-6 text-green-500" />
          </span>
          <Typography variant={TypographyVariant.BODY_STRONG} as="h3">
            Entre em contato com o nosso time
          </Typography>
        </div>
        <Typography variant={TypographyVariant.BODY_TEXT} as="p">
          Para suporte, dúvidas, reclamações ou sugestões sobre a parceria, entre em contato com nosso
          time de atendimento.
        </Typography>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button
            asChild
            variant="secondary"
            className="w-full"
            startIcon={faWhatsapp}
            data-testid={DataTestIdEnum.FAQ_SUPPORT_PROFESSIONALS_WHATSAPP_SAC}
          >
            <Link
              prefetch={false}
              href={whatsappUrl}
              target="_blank"
              data-analytics-event={AnalyticsEnum.CLICK_FAQ_WHATSAPP_PARTNER_SAC_BUTTON}
            >
              WhatsApp
            </Link>
          </Button>
          <Button
            asChild
            variant="secondary"
            className="w-full"
            startIcon={faEnvelope}
            data-testid={DataTestIdEnum.FAQ_EMAIL_SAC_BUTTON}
          >
            <Link
              prefetch={false}
              href={partnerSacEmail}
              target="_blank"
              data-analytics-event={AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_SAC_EMAIL_BUTTON}
            >
              Enviar e-mail
            </Link>
          </Button>
        </div>
      </Card>
    </section>
  );
};
